import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { StopwatchService } from 'src/app/services/stopwatch.service';
import { Subscription } from 'rxjs';

export interface CountdownTimer {
  seconds: number;
  secondsRemaining: number;
  hasStarted: boolean;
  hasFinished: boolean;
  displayTime: string;
}

@Component({
  selector: 'app-stopwatch',
  templateUrl: './stopwatch.component.html',
  styleUrls: ['./stopwatch.component.scss'],
})
export class StopwatchComponent implements OnInit {
  timer: CountdownTimer;
  public finishSubscription: Subscription;
  public isFinished = false;
  selectedMinutes = 0;
  selectedSeconds = 0;

  @Input() timeInSeconds: number;

  constructor(
    private modalCtrl: ModalController,
    public stopWatchService: StopwatchService,
  ) {
  }

  ngOnInit() {
    this.finishSubscription = this.stopWatchService.onFinish.subscribe(() => {
      this.isFinished = true;
    });
    this.initFromTimeInSeconds();
  }

  private initFromTimeInSeconds(): void {
    const total = Math.max(1, this.timeInSeconds ?? 60);
    this.selectedMinutes = Math.min(5, Math.floor(total / 60));
    this.selectedSeconds = Math.round((total % 60) / 5) * 5;
    if (this.selectedSeconds === 60) {
      this.selectedSeconds = 0;
      this.selectedMinutes = Math.min(5, this.selectedMinutes + 1);
    }
    this.syncTimeFromSliders();
  }

  syncTimeFromSliders(): void {
    this.timeInSeconds = this.selectedMinutes * 60 + this.selectedSeconds;
    if (this.timeInSeconds <= 0) {
      this.timeInSeconds = 5;
      this.selectedMinutes = 0;
      this.selectedSeconds = 5;
    }
  }

  ngOnDestroy() {
    if(this.finishSubscription) {
      this.finishSubscription.unsubscribe();
    }
  }

  getDisplayTime() {
    return this.getSecondsAsDigitalClock(this.stopWatchService.secondsRemaining);
  }

  getSecondsAsDigitalClock(inputSeconds: number) {
    const secNum = parseInt(inputSeconds.toString(), 10); // don't forget the second param
    const hours = Math.floor(secNum / 3600);
    const minutes = Math.floor((secNum - (hours * 3600)) / 60);
    const seconds = secNum - (hours * 3600) - (minutes * 60);
    let minutesString = '';
    let secondsString = '';
    minutesString = (minutes < 10) ? '0' + minutes : minutes.toString();
    secondsString = (seconds < 10) ? '0' + seconds : seconds.toString();
    return minutesString + ':' + secondsString;
  }

  hasFinished() {
    return this.timer?.hasFinished;
  }

  cancel() {
    this.stopWatchService.cancelTimer();
    this.modalCtrl.dismiss();
  }

  minimize() {
    this.modalCtrl.dismiss();
  }

  start() {
    this.syncTimeFromSliders();
    if (this.timeInSeconds <= 0) return;
    this.stopWatchService.startTimer(this.timeInSeconds);
  }
}
